import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { useAlert } from 'shared/components/alerts';
import { TriggerDataResponse } from 'api/services/workflow/workflow.schema';
import { sharedWorkflowService } from 'api/services';
import { Site } from 'shared/hooks';

export const useGetTriggerData = (site: Site, enabled: boolean = true) => {
  const { alertError } = useAlert();

  return useQuery<TriggerDataResponse>(
    QUERY_KEYS.workflows(),
    async () => await sharedWorkflowService.getTriggerData(site),
    {
      enabled,
      onError: (e) => alertError(e),
    }
  );
};
